$(document).ready(function(){
  $('#image-text-slider--enable').slick({
    slidesToShow: 3,
    arrows: true,
    prevArrow:'<div class="prev_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="31" viewBox="0 0 16 31"><g><g><path d="M.004 15.427c.027.38.18.739.436 1.02l12.247 13.609a1.702 1.702 0 1 0 2.53-2.275L3.991 15.31 15.217 2.84a1.702 1.702 0 1 0-2.53-2.276L.44 14.172a1.701 1.701 0 0 0-.436 1.255z"/></g></g></svg></div>',
    nextArrow:'<div class="next_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="31" viewBox="0 0 16 31"><g><g><path d="M.004 15.427c.027.38.18.739.436 1.02l12.247 13.609a1.702 1.702 0 1 0 2.53-2.275L3.991 15.31 15.217 2.84a1.702 1.702 0 1 0-2.53-2.276L.44 14.172a1.701 1.701 0 0 0-.436 1.255z"/></g></g></svg></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          variableWidth: true,
        }
      },
      {
        breakpoint: 828,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          variableWidth: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          variableWidth: true,
        }
      }
    ]
  });
  
  $(document).on("click",".video--play-btn",function(){
    $(this).fadeOut("slow");
    $(this).parents(".video_background_cover_main").fadeOut("slow")
    $(".video_play_push--wrapper").show();
    if($(this).hasClass("type_video")== true){
      $(this).parents(".hero__media").find(".hero__media-container").find("video").get(0).play();
    }else{
      window.YT_player.play();
    }
  });
  
  $(document).on("click",".video_push_btn",function(){
    if($(this).hasClass("push")){
      if($(this).hasClass("type_video")){
        $(this).parents(".hero__media").find(".hero__media-container").find("video").get(0).pause();
      }else{
        window.YT_player.pause();
      }
      $(this).find(".icon_push").hide();
      $(this).find(".icon_play").show();
    }else{
      if($(this).hasClass("type_video")){
        $(this).parents(".hero__media").find(".hero__media-container").find("video").get(0).play();
      }else{
        window.YT_player.play();
      }
      $(this).find(".icon_push").show();
      $(this).find(".icon_play").hide();
    }
    
    $(this).toggleClass("push");
  });
  
  
  if(document.querySelector('.custom_product--main .product-grid')){
    const slider = document.querySelector('.custom_product--main .product-grid');
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => isDown = false );
    slider.addEventListener('mouseup', () => isDown = false );
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
      //     console.log(walk);
    });
  }
  

  
  
  
  
  //--- Browser Details ---//
  function getBroswerDetails() {
    //Checking the user's OS and Browser
    if ((navigator.userAgent).includes("Android")) {
      $("body").addClass("android");
    } else if ((navigator.userAgent).includes("Mac")) {
      $("body").addClass("mac");
    } else {
      $("body").addClass("windows");
    }


    //-- Browser --//
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isFirefox = typeof InstallTrigger !== 'undefined';
    var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
      return p.toString() === "[object SafariRemoteNotification]";
    })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    var isEdge = !isIE && !!window.StyleMedia;
    var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
    var isBlink = (isChrome || isOpera) && !!window.CSS;
    if (isFirefox) {
      $("body").addClass("isFirefox")
    } else if (isChrome) {
      $("body").addClass("isChrome")
    } else if (isSafari) {
      $("body").addClass("isSafari")
    } else if (isOpera) {
      $("body").addClass("isOpera")
    } else if (isIE) {
      $("body").addClass("isIE")
    } else if (isEdge) {
      $("body").addClass("isEdge")
    } else if (isEdgeChromium) {
      $("body").addClass("isEdgeChromium")
    } else {
      $("body").addClass("isBlink a")
    }
  }
  
  getBroswerDetails();
  
    
  
});



$(window).load(function()
               {
  var phones = [{ "mask": "(###) ###-####"}, { "mask": "(###) ###-####"}];
  $('#phone').inputmask({ 
    mask: phones, 
    greedy: true, 
    definitions: { '#': { validator: "[0-9]", cardinality: 1}} });
});


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}